module.exports = __webpack_public_path__ + "img/form.562f47ac.png";